import { styled, spacing, Text } from '@thg-commerce/gravity-theme'
import { DrawFocus } from '../mixin/focus'

export const Container = styled.div`
  display: flex;
  flex-direction: row-reverse;
  text-decoration: none;
`

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`

export const AuthorImageContainer = styled.a`
  ${DrawFocus()}
  margin-right: calc(${spacing(2)} - 2px);
`

export const AuthorName = styled.a`
  ${Text('bodyText', 'alternate')};
  display: inline-block;
  text-decoration: none;
  align-self: flex-start;
  margin-bottom: ${spacing(0.75)};
  color: ${(props) => props.theme.colors.palette.greys.darker};

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`
